import { NgModule } from '@angular/core';
import { TooltipComponent } from './components/tooltip.component';
import { CommonModule } from '@angular/common';
import { MmIconModule } from '@metromarkets/components';

@NgModule({
    imports: [CommonModule, MmIconModule],
  declarations: [TooltipComponent],
  exports: [TooltipComponent],
})
export class TooltipModule {
}

export { TooltipPositions } from './models/tooltip-positions.model';
